import { useEffect, useState } from "react"
import { arrayOf, bool, number, shape, string } from "prop-types"
import { Box, Button, ToggleSwitch } from "@planningcenter/tapestry-react"
import { Loading } from "components/ui"
import {
  SettingPane,
  useSettings,
  SettingContextProvider
} from "components/admin/settingPanes/SettingPane"

const GeneralReminders = ({ loading, event, reminders: _r, attendeeTypes: _at }) => {
  const { isEditing, onLoading, onEditing, onCancel } = useSettings()

  useEffect(() => {
    onLoading(loading)
  }, [loading])

  const [isGeneralRemindersEnabled, setIsGeneralRemindersEnabled] = useState(
    event.general_reminders_enabled_at || false
  )

  const handleGeneralRemindersToggle = () => {
    onEditing(false)
    setIsGeneralRemindersEnabled(!isGeneralRemindersEnabled)
  }

  const handleCancel = () => {
    console.log("Cancelling General Reminder")
    onCancel()
  }

  const handleSave = () => {
    console.log("Saving General Reminder")
  }

  return (
    <SettingPane
      onSave={handleSave}
      onCancel={handleCancel}
      title={
        <>
          <ToggleSwitch
            label="General Reminders"
            disabled={loading}
            isChecked={isGeneralRemindersEnabled}
            onClick={handleGeneralRemindersToggle}
          />
        </>
      }
      blankState={
        !loading &&
        !isGeneralRemindersEnabled && (
          <>
            <Box marginBottom={1}>
              Enable General Reminders to keep your event top-of-mind for attendees to maximize
              attendance.
            </Box>
            <Button
              title="Enable general reminders"
              size="sm"
              theme="app"
              onClick={handleGeneralRemindersToggle}
            />
          </>
        )
      }
    >
      {loading && <Loading />}

      {!loading && isEditing && <Box>Placeholder: EditingForm</Box>}

      {!loading && !isEditing && (
        <Box>
          A reminder will be sent to all attendees at 6:00 pm on May 1, 2024 (2 days before the
          event).
        </Box>
      )}
    </SettingPane>
  )
}

GeneralReminders.propTypes = {
  loading: bool,
  event: shape({}),
  reminders: arrayOf(
    shape({
      id: number
    })
  ),
  attendeeTypes: arrayOf(
    shape({
      id: number,
      name: string
    })
  )
}

const GeneralRemindersWrapper = props => (
  <SettingContextProvider>
    <GeneralReminders {...props} />
  </SettingContextProvider>
)

export default GeneralRemindersWrapper
